import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ permissions, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (permissions.loading) {
      return "is Loading";
    }
    if (isEmpty(permissions.data)) {
      return <p className="is-size-2 has-text-centered has-text-grey">Found Nothing</p>;
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Slug</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {permissions.data.map(permission => (
            <tr key={permission.id}>
              <td>
                <a>{permission.id}</a>
              </td>
              <td>{permission.slug}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link to={`/permissions/${permission.id}/edit`} className="button  is-link is-small">
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(permission.id)}
                    to={`/permissions/${permission.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Permission/Index/Table.js